import { CONTENT_MAX_WIDTH } from "../../constants";

interface ContentWrapperProps {
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export const ContentWrapper = ({ style, children }: ContentWrapperProps) => {
  return (
    <div style={style}>
      <div
        style={{
          margin: 'auto',
          maxWidth: CONTENT_MAX_WIDTH,
          padding: 10,
          paddingTop: 50,
        }}
      >
        {children}
      </div>
    </div>
  );
};
